module.exports = __webpack_public_path__ + "img/5.bacf608b.png";